import type { FieldMinimalListResponseApi, LogicalDeviceListResponseApi } from '@ingenico/api-sdk-provisioning-public';
import type { FieldConfiguration } from '@ingenico/react-ui/advanced-search';
import type {
  PaginatedPublicLogicalDeviceList,
  PublicLogicalDevices,
} from '../../../model/logicalDeviceTotalList.model';

export function mapLogicalDeviceListResponseApiToPaginatedLogicalDeviceList({
  data,
  ...rest
}: LogicalDeviceListResponseApi): PaginatedPublicLogicalDeviceList {
  return {
    ...rest,
    logicalDevices: data.map(
      (element) =>
        ({
          ...element,
        }) as PublicLogicalDevices,
    ),
  };
}

export function mapperGetTotalCountOfLogicalDeviceByDynamicGroup(data: PaginatedPublicLogicalDeviceList): number {
  return data.pagination.totalResults ?? 0;
}

export function mapLogicalDeviceMinimalListToFieldConfiguration(
  response: FieldMinimalListResponseApi,
): FieldConfiguration[] {
  return response.map(({ key, type }) => ({
    key,
    type,
    visible: true,
    searchable: !key.includes('parent'),
  })) as FieldConfiguration[];
}
